<template>
  <v-dialog v-model="dialog" max-width="500" persistent>
    <v-card>
      <v-card-title class="headline">Reward Unlocked!</v-card-title>
      <v-card-text class="pt-4 text-body-1">
        You have unlocked the reward {{ pendingReward ? pendingReward.name : '' }}
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" @click="close">Awesome</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapFields } from 'vuex-map-fields'

export default {
  name: 'RewardUnlockedDialog',
  computed: {
    ...mapFields('onboarding_state', ['pendingReward']),
    dialog: {
      get() { return !!this.pendingReward },
      set(open) { if (!open) this.close() }
    }
  },
  watch: {
    pendingReward: {
      immediate: true,
      handler(val) {
        if (val && this.$confetti) {
          this.$confetti.start()
          setTimeout(() => this.$confetti.stop(), 3000)
        }
      }
    }
  },
  methods: {
    close() {
      this.pendingReward = null
      if (this.$confetti) this.$confetti.stop()
    }
  }
}
</script>
